import { useBrowserLocale } from './useLocale';
import countryToCurrency, { Countries } from 'country-to-currency';

/**
 * this approach relies on the user's locale settings and
 * might not always accurately reflect their preferred currency
 */
export const useCurrencyCodeFromBrowserLocale = () => {
  const { locales } = useBrowserLocale({});

  const primaryLocaleCountryCode = locales?.[0]?.split('-')?.[1] || 'US';

  return (primaryLocaleCountryCode in countryToCurrency && countryToCurrency[primaryLocaleCountryCode as Countries]) || countryToCurrency.US;
};
